import { animate, state, style, transition, trigger } from '@angular/animations';

/** Allineato a $transition-base (200ms) e easing in _variables.scss */
const MS = '200ms';
const EASING_IN = 'cubic-bezier(0.4, 0, 1, 1)';
const EASING_OUT = 'cubic-bezier(0, 0, 0.2, 1)';

export const toastItemSlideTrigger = trigger('toastSlide', [
  state(
    'in',
    style({
      opacity: 1,
      transform: 'translateX(0)',
    })
  ),
  state(
    'out',
    style({
      opacity: 0,
      transform: 'translateX(12px)',
    })
  ),
  transition('void => in', [
    style({ opacity: 0, transform: 'translateX(12px)' }),
    animate(`${MS} ${EASING_OUT}`),
  ]),
  transition('in => out', [animate(`${MS} ${EASING_IN}`)]),
]);
